import Raven from 'raven-js';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
const MEETINGS_URI = 'meetings/v1/link?includeAssociated=true';

// eslint-disable-next-line no-restricted-syntax
let cache;
const mapResponseToOptions = response => response.map(meeting => ({
  text: meeting.name,
  value: meeting.id,
  help: /*#__PURE__*/_jsx(UITruncateString, {
    children: meeting.slug
  }),
  item: meeting,
  url: meeting.link
}));

/**
 *
 * @param {Object} options
 * @param {Object} options.httpClient - and http client containing a `get` method
 * @returns {Promise}
 */
export function fetchMeetings({
  httpClient
}) {
  let promise;
  if (cache) {
    promise = Promise.resolve(cache);
    promise.catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
    return promise;
  }
  promise = httpClient.get(MEETINGS_URI).then(res => {
    cache = mapResponseToOptions(res);
    return cache;
  }).catch(error => {
    if (error.status === 404) {
      cache = [];
      return cache;
    }
    Raven.captureException(error, {
      extra: {
        cache
      }
    });
    return Promise.reject(error);
  });
  promise.catch(err => {
    setTimeout(() => {
      throw err;
    });
  });
  return promise;
}